import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LeistungDetailPage } from './leistung-detail';

@NgModule({
  declarations: [
    LeistungDetailPage,
  ],
  imports: [
    IonicPageModule.forChild(LeistungDetailPage),
  ],
})
export class LeistungDetailPageModule {}



// WEBPACK FOOTER //
// ./src/pages/leistung-detail/leistung-detail.module.ts